import clienteAxios from '../../helper/axios';
import { cargarHistoricoClienteEditable, cargarHistoricos } from './historicosSlice';

// export const startConsultarCreditosHistorico = () => async (dispatch) => {
//   try {
//     const respuesta = await clienteAxios.get('/admin/historicos', {
//       headers: {
//         'Content-Type': 'application/json',
//         'x-token': localStorage.getItem('token') || '',
//       },
//     });
//     dispatch(cargarHistoricos(respuesta.data.historicos));
//   } catch (error) {
//     console.error(error);
//   }
// };


// eslint-disable-next-line consistent-return
export const startConsultarCreditosHistorico = (desde, hasta) => async (dispatch) => {
  try {
    const params = new URLSearchParams();
    if (desde) params.append('desde', desde);
    if (hasta) params.append('hasta', hasta);

    const respuesta = await clienteAxios.get(`/admin/historicos?${params}`, {
      headers: {
        'Content-Type': 'application/json',
        'x-token': localStorage.getItem('token') || '',
      },
    });
    dispatch(cargarHistoricos(respuesta.data.historicos));
    return respuesta.data;
  } catch (error) {
    console.error(error);
  }
};

export const startHistoricoClienteEditable = (id) => async (dispatch) => {
  try {
    const respuesta = await clienteAxios.get(`admin/historicos/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'x-token': localStorage.getItem('token') || '',
      },
    });
    dispatch(cargarHistoricoClienteEditable(respuesta.data.historicos));
  } catch (error) {
    console.error(error);
  }
};

// export const startConsultarCreditosPaginados = (page = 1, searchTerm = '') => async (dispatch) => {
//   try {
//     const params = new URLSearchParams({
//       page: page.toString(),
//       limit: '20'
//     });
 
//     if (searchTerm.trim()) {
//       params.append('search', searchTerm.trim());
//     }
 
//     const respuesta = await clienteAxios.get(`/admin/creditos?${params}`, {
//       headers: {
//         'Content-Type': 'application/json',
//         'x-token': localStorage.getItem('token') || ''
//       }
//     });
 
//     dispatch(cargarHistoricos(respuesta.data));
//   } catch (error) {
//     console.error(error);
//   }
//  };


export const startConsultarCreditosPaginados = (page = 1, searchTerm = '', filtroEspecifico = null) => async (dispatch) => {
  try {
    // Asegurarse de que page sea un número válido
    const pageNumber = parseInt(page, 10) || 1;
    
    const params = new URLSearchParams({
      page: pageNumber.toString(),
      limit: '20'
    });
 
    // Si hay un filtro específico, agregamos el tipo de filtro y su valor
    if (filtroEspecifico && filtroEspecifico.valor) {
      const { tipo, valor } = filtroEspecifico;
      
      // Agregamos el tipo de filtro específico
      if (tipo === 'creditoId') {
        params.append('creditoId', valor);
      } else if (tipo === 'cedula') {
        params.append('cedula', valor);
      } else if (tipo === 'nombre') {
        params.append('nombre', valor);
      }
      
      // También enviamos el tipo para que el backend sepa qué campo filtrar
      params.append('tipoFiltro', tipo);
    }
    // De lo contrario, usamos el término de búsqueda general
    else if (searchTerm && searchTerm.trim()) {
      // Búsqueda general
      params.append('search', searchTerm.trim());
    }
 
    console.log(`Consultando página ${pageNumber}, filtros:`, 
      filtroEspecifico ? `${filtroEspecifico.tipo}=${filtroEspecifico.valor}` : 
      (searchTerm ? `búsqueda=${searchTerm}` : 'sin filtros'));
    
    const respuesta = await clienteAxios.get(`/admin/allh?${params}`, {
      headers: {
        'Content-Type': 'application/json',
        'x-token': localStorage.getItem('token') || ''
      }
    });


    if (respuesta.data) {
      dispatch(cargarHistoricos({
        creditos: respuesta.data.creditos || [],
        total: respuesta.data.total || 0,
        page: pageNumber,
        totalPages: respuesta.data.totalPages || 0
      }));
    } else {
      console.error('La respuesta del servidor no contiene datos válidos');
    }
  } catch (error) {
    console.error('Error al consultar créditos paginados:', error);
    dispatch(cargarHistoricos({
      creditos: [],
      total: 0,
      page: 1,
      totalPages: 0
    }));
  }
};

// eslint-disable-next-line consistent-return
export const startConsultarTodosHistoricosParaInforme = (desde, hasta) => async (dispatch) => {
  try {
    const params = new URLSearchParams();
    if (desde) params.append('desde', desde);
    if (hasta) params.append('hasta', hasta);

    const respuesta = await clienteAxios.get(`/admin/historicosSinPaginar?${params}`, {
      headers: {
        'Content-Type': 'application/json',
        'x-token': localStorage.getItem('token') || '',
      },
    });
    
    // No actualizamos el estado de paginación ya que este endpoint no la utiliza
    dispatch(cargarHistoricos({
      creditos: respuesta.data.historicos || [],
      total: respuesta.data.historicos?.length || 0,
      page: 1,
      totalPages: 1
    }));
    
    return respuesta.data;
  } catch (error) {
    console.error('Error al consultar históricos para informe:', error);
    return { historicos: [] };
  }
};